import type { Playbook } from '@squadlab/contracts';

/**
 * HR letter playbook v1 (ADR 0052; letters function). The agent drafts the
 * requested letter bilingually (EN + AR) from the employee record; the
 * operator reviews wording at the gate; the record-update marks it issued.
 * The approved artifact on the case trail IS the letter — print-ready text.
 */
export const LETTER_PLAYBOOK: Playbook = {
  key: 'hr-letter',
  version: 1,
  function: 'letters',
  title: 'HR letter',
  steps: [
    {
      id: 'draft-letter',
      kind: 'agent-draft',
      title: 'Draft the letter (English + Arabic)',
      instruction: 'Author the requested letter from the employee record, bilingual, ready to print on letterhead.',
    },
    {
      id: 'gate-issue',
      kind: 'human-gate',
      title: 'Operator review before issuing',
      instruction: 'Approve to issue the letter, request a redo of the wording, or reject the request.',
    },
    {
      id: 'record-issued',
      kind: 'record-update',
      title: 'Mark the letter as issued',
    },
  ],
};
